// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/prototyping-explained/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const prototypingExplainedEN: PageEntry = {
  id: "post.mustererstellung",
  locale: "en",
  slug: "prototyping-explained",
  seo: {
    title: "Glossary: Prototyping explained simply | Dietz GmbH",
    description: "Prototyping is the process of producing physical models or prototypes based on sample designs and developments. This step makes it possible to test the sample in reality, check its",
  },
  type: "post",
  h1: "Glossary: Prototyping explained simply",
  intro: "Prototyping is the process of producing physical models or prototypes based on sample designs and developments. This step makes it possible to test the sample in reality, check its functionality and make any necessary adjustments before mass production. Sample creation is particularly important in areas such as the textile industry, where garments are tested before production to optimise fit, material selection and design. An efficient sample creation process contributes to quality and efficiency.",
  blocks: [

  ],
};
